import { Controller } from '@hotwired/stimulus';

// Gestes de l'aperçu du tableau de bord de la landing (Landing::HeroPreviewComponent) : les
// onglets changent de contenu, les liens de la sidebar montrent le squelette de leur liste (une
// grille pour l'Académie), « Nouveau contrat » ouvre une maquette du sélecteur de produit, le
// bouton de repli replie la sidebar. Rien n'est réel : c'est pour que l'aperçu réponde au clic.
//
// Tout passe par des classes (`is-active`, `is-skeleton`, `is-page`, `is-collapsed`), le style et
// les animations sont dans components/_landing_hero_preview.scss. Sans ce contrôleur, l'aperçu
// affiche simplement l'onglet Portefeuille.
export default class extends Controller {
  static targets = ['tab', 'panel', 'navItem'];

  connect() {
    this.currentTab = 'portfolio';
  }

  selectTab(event) {
    this.currentTab = event.currentTarget.dataset.tab;
    this.tabTargets.forEach((tab) => tab.classList.toggle('is-active', tab === event.currentTarget));
    this.activateNavItem(this.navItemTargets.find((item) => item.dataset.page === 'dashboard'));
    this.show('dashboard', this.currentTab);
  }

  // « Tableau de bord » ramène à l'onglet courant ; les autres liens n'ont pas de maquette propre,
  // ils montrent le squelette de leur page : un tableau, ou une grille de cartes (`data-page="grid"`).
  selectNav(event) {
    const item = event.currentTarget;
    this.activateNavItem(item);

    if (item.dataset.page === 'dashboard') {
      this.show('dashboard', this.currentTab);
    } else {
      this.show('skeleton', item.dataset.page);
    }
  }

  // Comme dans l'app, aucun lien de la sidebar n'est actif sur cette page.
  newContract() {
    this.activateNavItem(null);
    this.show('page', 'new');
  }

  toggleSidebar() {
    this.element.classList.toggle('is-collapsed');
  }

  activateNavItem(active) {
    this.navItemTargets.forEach((item) => item.classList.toggle('is-active', item === active));
  }

  // `mode` règle l'habillage (onglets et bandeau, cf. le SCSS), `panel` ce qui est affiché.
  show(mode, panel) {
    this.element.classList.toggle('is-skeleton', mode === 'skeleton');
    this.element.classList.toggle('is-page', mode === 'page');
    this.showPanel(panel);
  }

  // Retirer puis remettre la classe force le rejeu des animations d'arrivée, y compris quand on
  // reclique sur le panneau déjà affiché (deux liens de sidebar d'affilée).
  showPanel(id) {
    this.panelTargets.forEach((panel) => {
      panel.classList.remove('is-active');
      if (panel.dataset.panel !== id) return;

      void panel.offsetWidth;
      panel.classList.add('is-active');
    });
  }
}
